import { observeQuickView } from "../woocommerce/observeQuickView";

export class SidePanelSize {
  constructor(selectInput) {
    if (selectInput.id !== "pa_taille") return;
    this.selectInput = selectInput;
    this.elementAttributeName = selectInput.id;
    this.body = document.body;
    this.header = document.getElementById("header");
    this.navbar = document.querySelector(".navbar");

    const closestTr = this.selectInput.closest("tr");
    closestTr.classList.add("side-panel-sizes");
    this.toggleSidePanel = closestTr.querySelector(".size-variation");
    this.sidePanel = closestTr.querySelector(".side-panel-sizes-nav");
    this.sidePanelOverlay = closestTr.querySelector(".side-panel-overlay");
    this.sidePanelItems = [];
    this.isPanelOpen = false;

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.init();
  }

  isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  isSmallScreen() {
    return window.matchMedia("(max-width: 576px)").matches;
  }

  getSelectedAttribute() {
    return window.sidePanelSizes.productVariationAttributes.reduce(
      (attributes, attributeName) => {
        const attribute = document.querySelector(
          `form.variations_form #${attributeName}`
        );
        if (attribute) {
          attributes[`${attributeName}`] = {
            slug: attribute.value,
            name: attribute.options[attribute.selectedIndex]?.text || "",
          };
        }
        return attributes;
      },
      {}
    );
  }

  init() {
    if (this.toggleSidePanel) {
      this.toggleSidePanel.addEventListener("click", () =>
        this.isPanelOpen ? this.hidePanel() : this.showPanel()
      );
    }

    window.addEventListener("resize", () => {
      if (this.isDesktop()) this.hidePanel();
    });

    let $this = this;
    jQuery("form.variations_form").on("found_variation", function () {
      $this.buildOptions();
    });

    this.buildOptions();
  }

  showPanel() {
    if (this.isPanelOpen) return;
    this.isPanelOpen = true;

    this.toggleSidePanel?.classList.add("isActive");
    this.sidePanel?.classList.add("isActive");
    this.sidePanelOverlay?.classList.add("isActive");
    this.body.classList.add("menuIsOpen");
    if (this.header) this.header.classList.add("menuIsOpen");

    if (
      this.body.classList.contains("single-product") &&
      this.isSmallScreen()
    ) {
      this.navbar?.classList.replace("isLight", "isDark");
    }

    this.sidePanelItems.forEach((item) =>
      item.addEventListener("click", this.handleClickItem.bind(this))
    );
    this.closeButton?.addEventListener("click", () => this.hidePanel());

    setTimeout(() => {
      document.addEventListener("click", this.handleClickOutside);
    }, 1);
  }

  hidePanel() {
    if (!this.isPanelOpen) return;
    this.isPanelOpen = false;

    document.removeEventListener("click", this.handleClickOutside);

    this.toggleSidePanel?.classList.remove("isActive");
    this.sidePanel?.classList.remove("isActive");
    this.sidePanelOverlay?.classList.remove("isActive");
    this.body.classList.remove("menuIsOpen");
    if (this.header) this.header.classList.remove("menuIsOpen");
  }

  handleClickOutside(event) {
    if (this.sidePanel?.contains(event.target)) {
      event.stopPropagation();
      return;
    }
    this.hidePanel();
  }

  buildOptions() {
    this.setValuesInToggleSidePanel();
    const optionsContainer = this.sidePanel?.querySelector(
      ".side-panel-sizes-nav__options"
    );
    if (optionsContainer) {
      optionsContainer.innerHTML = this.buildHTMLOptions();
    }
    this.sidePanelItems =
      this.sidePanel?.querySelectorAll(".side-panel-sizes-nav__item") || [];
    this.closeButton = this.sidePanel?.querySelector(
      ".side-panel-sizes-nav__close"
    );
    if (this.sidePanel) this.sidePanel.style.display = "block";
  }

  buildHTMLOptions() {
    return Object.entries(window.sidePanelSizes.sortedOptions)
      .map(
        ([width, sizes]) => `
        <div class="side-panel-sizes-nav__group">
          <div class="side-panel-sizes-nav__header">Largeur: ${width} cm</div>
          ${Object.entries(sizes)
            .map(([length, size]) => {
              const variant = this.matchVariantBySize(size.slug);
              return variant
                ? `<div class="side-panel-sizes-nav__item" data-option="${size.slug}" data-variation-id="${variant.variation_id}">
                    <div class="side-panel-sizes-nav__item-name">
                      <div class="side-panel-sizes-nav__size">${size.name}</div>
                      <div class="side-panel-sizes-nav__price">${variant.display_price}</div>
                    </div>
                   </div>`
                : "";
            })
            .join("")}
        </div>
      `
      )
      .join("");
  }

  matchVariantBySize(size) {
    const selectedAttributes = { ...this.getSelectedAttribute() };
    selectedAttributes[`${this.elementAttributeName}`].slug = size;

    return window.sidePanelSizes.productAttributesPrices.find((variant) =>
      Object.keys(selectedAttributes).every(
        (key) => variant.attributes[key] === selectedAttributes[key].slug
      )
    );
  }

  setValuesInToggleSidePanel() {
    const selectedAttributes = this.getSelectedAttribute();
    const matchingVariant = window.sidePanelSizes.productAttributesPrices.find(
      (variant) =>
        Object.keys(selectedAttributes).every(
          (key) => variant.attributes[key] === selectedAttributes[key].slug
        )
    );

    if (matchingVariant) {
      const selectedValueElement = this.toggleSidePanel?.querySelector(
        ".size-variation__selected-value"
      );
      const priceElement = this.toggleSidePanel?.querySelector(
        ".size-variation__price"
      );

      if (selectedValueElement) {
        selectedValueElement.textContent =
          selectedAttributes[`${this.elementAttributeName}`].name;
      }
      if (priceElement) {
        priceElement.innerHTML = matchingVariant.display_price;
      }
    }
  }

  handleClickItem(event) {
    this.hidePanel();
    const variationIdInput = document.querySelector(
      "form.variations_form .variation_id"
    );
    if (variationIdInput)
      variationIdInput.value =
        event.currentTarget.getAttribute("data-variation-id");
    this.selectInput.value = event.currentTarget.getAttribute("data-option");
    jQuery(this.selectInput).trigger("change");
    observeQuickView();
  }
}

export const setupSidePanelSizes = () => {
  jQuery("body").on("yith_wccl_form_initialized", function () {
    document
      .querySelectorAll("form.variations_form select#pa_taille")
      .forEach((selectInput) => {
        new SidePanelSize(selectInput);
      });
  });
};
